import produce from "immer";

const defaultState = {
	error: null
};

export default function(state = defaultState, action) {
	switch (action.type) {
		case 'FETCH_REWARD':
			return defaultState;
		case "CLAIM_REWARD":
			return defaultState;
		case "REWARD_CLAIMED":
			return defaultState;
		case 'ACCOUNT_LIMIT_EXCEEDED':
			return produce(state, draft => {
				draft.error = action.type;
			});
		case 'REWARD_OUT_OF_STOCK':
			return produce(state, draft => {
				draft.error = action.type;
			});
		case 'REWARD_NOT_ACTIVE':
			return produce(state, draft => {
				draft.error = action.type;
			});
		case 'INVALID_AMOUNT':
			return produce(state, draft => {
				draft.error = action.type;
			});
		default:
			return state;
	}
}
